import { Avatar } from "antd";
import { QuestionOutlined } from "@ant-design/icons";

export const FormatDataCustomerJson = (jsonString) => {
  if (!jsonString) return null;

  // ถ้าเป็น Object อยู่แล้วให้ส่งคืนเลย
  if (typeof jsonString === "object") return jsonString;

  try {
    // พยายาม Parse ถ้าเป็น String
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("FormatDataCustomerJson Error:", error);
    return null;
  }
};


export const FormatDataSettleSlip = (jsonString) => {
  if (!jsonString) return null;

  let parsedData;
  try {
    // แก้ไขปัญหา String ซ้อน String ในแบบที่ 2
    parsedData = typeof jsonString === "string" ? JSON.parse(jsonString) : jsonString;
      
    if (typeof parsedData === "string") {
      parsedData = JSON.parse(parsedData);
    }
  } catch (error) {
    console.error("JSON Parsing Error:", error);
    return null;
  }

  // --- แยกแยะระหว่าง แบบที่ 1 (KBiz/Direct) และ แบบที่ 2 (Standard Structure) ---

  // ตรวจสอบว่าเป็นแบบที่ 1 (ดูจาก key transType หรือ errorCode)
  const isType1 = parsedData.transType || parsedData.errorCode === "00";

  // ดึงข้อมูลหลัก (Detail)
  const slipDetail = isType1 ? parsedData : parsedData?.data?.content?.[0];
  const instruction = parsedData?.instruction;

  if (!slipDetail) {
    return {
      data: parsedData,
      status: parsedData?.success || false,
      error: parsedData?.message || "Data detail not found",
      message: "",
    };
  }

  // สร้าง Object มาตรฐาน (Mapping Fields)
  const formattedSlip = {
    // ข้อมูลสถานะ
    status: isType1
      ? slipDetail.transStatus === "S"
      : slipDetail.status === "ส่งเรียบร้อย",
    message: isType1 ? slipDetail.errorMsg || "Success" : parsedData.message,

    // ข้อมูลบัญชีต้นทาง
    fromAccountNameTh:
      slipDetail.accountHolderNameTh ||
      slipDetail.fromAccountNameTh ||
      slipDetail.fromAccountName ||
      "N/A",
    fromAccountNameEn:
      slipDetail.accountHolderNameEn || slipDetail.fromAccountNameEn || "N/A",
    fromAccountNo: slipDetail.fromAccountNo || "N/A",

    // ข้อมูลบัญชีปลายทาง
    toAccountNameTh:
      slipDetail.beneficiaryName ||
      slipDetail.payeeNameTh ||
      slipDetail.newPayeeNameTh ||
      "N/A",
    toAccountNameEn:
      slipDetail.payeeNameEn || slipDetail.newPayeeNameEn || "N/A", // แบบที่ 1 ไม่มี EN โดยตรง
    toAccountNo:
      slipDetail.beneficiaryNo ||
      slipDetail.toAccountNo ||
      slipDetail.newPayeeAccountNo ||
      "N/A",
    toBankCode:
      slipDetail.bankCode ||
      slipDetail.payeeBankCode ||
      slipDetail.newPayeeBankCode ||
      "N/A",
    toBankNameTh:
      slipDetail.payeeBankNameTh ||
      slipDetail.newPayeeBankNameTh ||
      slipDetail.bankAbv ||
      "N/A",

    // ข้อมูลรายการโอน (แปลงเป็น Number เพื่อความแม่นยำ)
    amount: Number(slipDetail.amount || 0),
    transferFee: Number(slipDetail.feeAmount || slipDetail.transferFee || 0),
    netAmount: Number(
      slipDetail.totalAmount ||
        slipDetail.netAmount ||
        Number(slipDetail.amount) + Number(slipDetail.transferFee || 0)
    ),

    // ข้อมูลอ้างอิง
    transferOrderId: slipDetail.transferOrderId || slipDetail.rqUID,
    instructionRefNo:
      slipDetail.reqRefNo ||
      slipDetail.instructionRefNo ||
      instruction?.instructionRefNo,
    effectiveDate: slipDetail.effectiveDate,
    createdDateTime: slipDetail.createDate || slipDetail.createdDateTime,
    updatedDateTime:
      parsedData?.data?.updatedDateTime || slipDetail.effectiveDate,
  };

  return {
    data: formattedSlip,
    submittedDateTime: instruction?.submittedDateTime || slipDetail.createDate,
    updatedDateTime:
      parsedData?.data?.updatedDateTime || slipDetail.effectiveDate,
    status: isType1
      ? slipDetail.errorCode === "00"
      : parsedData.success || false,
    message: formattedSlip.message,
    error: "",
  };
};

export const FormatDataSettleSlipJson = (jsonString) => {
  if (!jsonString) {
    return null;
  }
  try {
    const settleSlip = JSON.parse(jsonString);
    // Now you can access the data like this:
    return { ...settleSlip };
  } catch (error) {
    return null;
  }
};
export const FormatDataImgBank = (bankCode) => {
  try {
    switch (bankCode) {
      case "SCB":
        return (
          <Avatar
            size="small"
            src={`/src/assets/images/bank/scb.png`}
            alt="SCB Logo"
          />
        );
      case "KBANK":
        return (
          <Avatar
            size="small"
            src={`../../assets/images/bank/kbank.png`}
            alt="KBank Logo"
          />
        );
      case "BBL":
        return (
          <Avatar
            size="small"
            src={`../../assets/images/bank/bbl.png`}
            alt="BBL Logo"
          />
        );
      default:
        return <Avatar size="small" icon={<QuestionOutlined />} />;
    }
  } catch (error) {
    return null; // ในกรณีที่เกิดข้อผิดพลาด
  }
};
